import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Divider, Stack, Text } from '@sixui/ui';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';
import type { IAppPricingTablePlan } from './plans';
import { commonStyles } from '~/styles/commonStyles';
import { appPricingTablePlans } from './plans';

export type IAppPricingTableFeatureProps = IContainerProps & {
  label: React.ReactNode;
  supportingText?: React.ReactNode;
  plan?: IAppPricingTablePlan;
  plans?: Array<IAppPricingTablePlan>;
  children?: React.ReactNode;
  values?: Record<IAppPricingTablePlan, React.ReactNode>;
  hideBadges?: boolean;
  last?: boolean;
};

const styles = stylex.create({
  available: {
    color: 'green',
    fontSize: '1.2em',
  },
  locked: {
    color: colorSchemeTokens.error,
    fontSize: '1.2em',
  },
});

function isPlanEnabled(
  plan: IAppPricingTablePlan,
  currentPlan: IAppPricingTablePlan,
  enabledPlans: Array<IAppPricingTablePlan> | undefined,
): boolean {
  if (
    enabledPlans &&
    enabledPlans.length > 0 &&
    enabledPlans.indexOf(plan) > 0
  ) {
    return true;
  } else if (
    appPricingTablePlans.indexOf(currentPlan) <=
    appPricingTablePlans.indexOf(plan)
  ) {
    return true;
  }

  return false;
}

export const AppPricingTableFeature: React.FC<IAppPricingTableFeatureProps> = (
  props,
) => {
  const {
    label,
    supportingText,
    plan: currentPlan = 'free',
    plans: enabledPlans,
    children,
    values,
    hideBadges,
    last,
  } = props;

  return (
    <>
      <Stack>
        <Text variant="label" size="lg">
          {label}
        </Text>
        {supportingText && (
          <Text variant="body" size="sm" dimmed>
            {supportingText}
          </Text>
        )}
      </Stack>

      {appPricingTablePlans.map((plan) => (
        <Stack key={plan} align="center" gap={1}>
          {!hideBadges &&
            (isPlanEnabled(plan, currentPlan, enabledPlans) ? (
              <FontAwesomeIcon
                icon={faCircleCheck}
                {...stylex.props(styles.available)}
              />
            ) : (
              <FontAwesomeIcon
                icon={faCircleXmark}
                {...stylex.props(styles.locked)}
              />
            ))}

          {values?.[plan] !== undefined && values[plan] !== null && (
            <Text variant="body" size={hideBadges ? 'md' : 'sm'}>
              {typeof values[plan] === 'boolean' ? (
                values[plan] ? (
                  <FontAwesomeIcon
                    icon={faCircleCheck}
                    {...stylex.props(styles.available)}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faCircleXmark}
                    {...stylex.props(styles.locked)}
                  />
                )
              ) : (
                values[plan]
              )}
            </Text>
          )}

          {children}
        </Stack>
      ))}

      {!last && <Divider sx={commonStyles.colSpanFull} />}
    </>
  );
};
